<template>
    <Popup v-if="$showLanguageSwitch" :open="open" :hideClose="true" @open="this.$emit('update:open', close())" :padding="true">
        <strong class="text-xl">
            {{ $t('language_selection_other_version_available') }}
        </strong>
        <div class="mt-2">
            <p v-if="applicationRegion === 'de'">
                {{
                    $t('language_changed_notice', {
                        url: getTargetApplicationUrl()
                    })
                }}
                {{
                    $t('stay_or_switch_question	', {
                        url: getTargetApplicationUrl()
                    })
                }}
            </p>

            <p v-if="applicationRegion === 'ch'">
                {{
                    $t('language_changed_notice', {
                        url: getApplicationUrl()
                    })
                }}
                {{
                    $t('stay_or_switch_question	', {
                        url: getApplicationUrl()
                    })
                }}
            </p>

            <div v-if="applicationRegion === 'de'" class="flex flex-col lg:flex-row justify-between gap-4 mx-auto mt-4">
                <button @click="close()" class="btn white">
                    {{
                        $t('stay_on_url', {
                            url: getApplicationUrl()
                        })
                    }}
                </button>

                <button @click="redirect('ch')" class="btn primary">
                    {{
                        $t('switch_to_url', {
                            url: getTargetApplicationUrl()
                        })
                    }}
                </button>
            </div>
            <div v-if="applicationRegion === 'ch'" class="flex flex-col lg:flex-row justify-between gap-4 mx-auto mt-4">
                <button @click="close()" class="btn white">
                    {{
                        $t('stay_on_url', {
                            url: getTargetApplicationUrl()
                        })
                    }}
                </button>

                <button @click="redirect('de')" class="btn primary">
                    {{
                        $t('switch_to_url', {
                            url: getApplicationUrl()
                        })
                    }}
                </button>
            </div>
        </div>
    </Popup>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '../api';
import { getQueryParameterByName } from '../helpers';

export default {
    data: () => ({
        open: false,
        applicationRegion: window.meta.region_configuration.region,
        targetApplicationRegion: window.meta.region_configuration.region === 'de' ? 'ch' : 'de',
        userCountry: undefined,
        userRegion: undefined,
        environment: undefined,
        urls: {
            de: {
                local: 'www.hkcm.test',
                staging: 'staging.hkcmanagement.de',
                dev: 'dev.hkcmanagement.de',
                prod: 'www.hkcmanagement.de'
            },
            ch: {
                local: 'www.hkcmglobal.test',
                staging: 'staging.hkcmglobal.com',
                dev: 'dev.hkcmglobal.com',
                prod: 'www.hkcmglobal.com'
            }
        }
    }),
    async mounted() {
        if (window.location.href.includes('test')) {
            this.environment = 'local';
        } else if (window.location.href.includes('staging')) {
            this.environment = 'staging';
        } else if (window.location.href.includes('dev')) {
            this.environment = 'dev';
        } else {
            this.environment = 'prod';
        }

        await this.load();
    },
    methods: {
        async load() {
            // if the user is logged in the location is not necessary it takes the user language / country
            if (this.$store.getters['user/isLoggedIn']) {
                return;
            }

            // check if the local user has already seen the popup during his session, do nothing
            if (getQueryParameterByName('regionPopupViewed')) {
                sessionStorage.setItem('regionPopupViewed', true);
                return;
            }

            if (sessionStorage.getItem('regionPopupViewed')) {
                return;
            }

            await api.get('/get-country').then((response) => {
                this.userCountry = response.data.country;
            });

            // determine the users region based on the country
            this.userCountry === 'de'
                ? (this.userRegion = 'de') // set region of user to de if country is de
                : (this.userRegion = 'ch'); // set region of user to ch if country is other than ch

            // determine if the user should be receiving the popup
            if (this.applicationRegion.toLowerCase() !== this.userRegion.toLowerCase()) {
                this.open = true;
            }
        },
        redirect(targetRegion) {
            sessionStorage.setItem('regionPopupViewed', true);

            window.location.href = `https://${this.urls[targetRegion][this.environment]}?regionPopupViewed=true`;
        },
        async close() {
            sessionStorage.setItem('regionPopupViewed', true);

            this.open = false;
        },
        getApplicationUrl() {
            return this.urls[this.applicationRegion][this.environment].replace('www.', '');
        },
        getTargetApplicationUrl() {
            return this.urls[this.targetApplicationRegion][this.environment].replace('www.', '');
        }
    },
    computed: {
        ...mapGetters('user', {
            user: 'get'
        }),
        ...mapGetters('countries', {
            countries: 'get'
        })
    }
};
</script>
